"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _BlogSettingsPageContainer = _interopRequireDefault(require("../BlogSettingsPageContainer"));

var _AsyncDateFormatsSettings = _interopRequireDefault(require("./AsyncDateFormatsSettings"));

var _default = function _default() {
  return _react.default.createElement(_BlogSettingsPageContainer.default, null, _react.default.createElement(_AsyncDateFormatsSettings.default, null));
};

exports.default = _default;
module.exports = exports.default;